import { createFormReducer } from '@td/utils';
import { PROVIDER_SURGE_INCENTIVE_EDIT_FORM } from '../action-types';

export default createFormReducer({
  fields:          ['id', 'start-date', 'end-date', 'amount', 'status'],
  formActionTypes: PROVIDER_SURGE_INCENTIVE_EDIT_FORM
});
